export const DOMAIN_CONFIG: Record<string, any> = {
  'localhost': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
    proctoringServerEnabled: true,   // GPU proctoring machine start/stop, kept on for local testing
    proctoringAllowedEmails: ['saswat@f360.com'],
  },
  // Kept because the tenant interceptor looks up host:port when a port is set.
  'localhost:4200': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
  },
  'f360qa.foyr.com': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
    proctoringServerEnabled: false,
  },
  'fractal360.in': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
    proctoringServerEnabled: false,
  },
  'f360.foyr.com': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
    proctoringServerEnabled: false,
  },
  'fractal.iqigai.ai': {
    tenantId: 'FRACTAL',          // Custom property to define the tenant
    ssoLoginEnabled: true,
    proctoringServerEnabled: false,
  },

  //These are added for managing proctoring machine feature access.
  'qa.iqigai.ai': {
    proctoringServerEnabled: true,
    proctoringAllowedEmails: ['saswat@f360.com'],
  },
  'app.iqigai.ai': {
    tenantId: 'IQIGAI',
    proctoringServerEnabled: true,
    proctoringAllowedEmails: ['admin@fractal.com'],
  },
  // 'qa.iqigai.ai': {
  //   tenantId: 'IQIGAI',          // Custom property to define the tenant
  //   ssoLoginEnabled: false,
  // },
   'qa.iqigai.ai:4500': {
    tenantId: 'FRACTAL',          // Custom property to define the tenant
    ssoLoginEnabled: true,
  },
   '3.111.204.98:4500': {
    tenantId: 'FRACTAL',          // Custom property to define the tenant
    ssoLoginEnabled: true,
  },
  'perprod.iqigai.ai': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
  },
  // 'app.iqigai.ai': {
  //   tenantId: 'IQIGAI',          // Custom property to define the tenant
  //   ssoLoginEnabled: false,
  // },

  'linde.iqigai.ai' : {
    tenantId: 'LINDE',
    proctoringServerEnabled: false,
    proctoringAllowedEmails: ['admin@fractal.com'],
  },
  'tessolve.iqigai.ai': {
    tenantId: 'TESSOLVE',          // Custom property to define the tenant
    ssoLoginEnabled: false,
  },
  'bmw.iqigai.ai': {
    tenantId: 'BMW',          // Custom property to define the tenant
    ssoLoginEnabled: false,
  },
  'recruiters.iqigai.ai': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
  },
  'qatessolve.edge.iqigai.ai': {
    tenantId: 'TESSOLVE',          // Custom property to define the tenant
    ssoLoginEnabled: false,
  },
  'qabmw.edge.iqigai.ai': {
    tenantId: 'BMW',          // Custom property to define the tenant
    ssoLoginEnabled: false,
  },
  'qahr.edge.iqigai.ai': {
    tenantId: 'IQIGAI',          // Custom property to define the tenant
    ssoLoginEnabled: false,
  },
};
